import { atom } from 'recoil';

export const isSuggestionLoadingAtom = atom<boolean>({
  key: 'CORE_EXPLORE/PORTFOLIO/LOADING_SUGGESTION_DATA_ATOM',
  default: false,
});
